<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="任务名称">
              <a-input placeholder="请输入任务名称" v-model="queryParam.taskName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12" :xs="24">
            <a-form-item label="任务状态" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-select
                  v-model="queryParam.status"
                  placeholder="请选择任务状态"
                  allowClear
                  style="width: 100%">
                <a-select-option value="0">待处理</a-select-option>
                <a-select-option value="1">处理中</a-select-option>
                <a-select-option value="2">已完成</a-select-option>
                <a-select-option value="3">失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12" :xs="24">
            <a-form-item label="开始时间" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-range-picker
                  v-model="queryParam.startTimeRange"
                  style="width: 100%"
                  :show-time="{ format: 'HH:mm',defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="[$t('antd.table.startTime'), $t('antd.table.endTime')]"
                  @change="onDateChange"
                  @ok="onDateOk"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="refreshData" type="primary" icon="reload" :loading="loading">刷新</a-button>
      <!--      <a-button @click="clearCompletedTasks" type="danger" icon="delete" style="margin-left: 8px">清理已完成任务</a-button>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <!--      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">-->
      <!--        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a-->
      <!--          style="font-weight: 600">{{ selectedRowKeys.length }}</a>&nbsp;项&nbsp;&nbsp;-->
      <!--        <a style="margin-left: 24px" @click="onClearSelected">清空</a>-->
      <!--      </div>-->

      <a-table
          ref="table"
          bordered
          size="middle"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :scroll="{ x: 1200 }"
          @change="handleTableChange">

        <template slot="statusSlot" slot-scope="text, record">
          <a-tag :color="getStatusColor(record.status)">
            {{ getStatusText(record.status) }}
          </a-tag>
        </template>

        <template slot="exportTypeSlot" slot-scope="text, record">
          {{ getExportTypeText(record.exportType) }}
        </template>

        <template slot="progressSlot" slot-scope="text, record">
          <a-progress
              v-if="record.status === 1"
              :percent="record.progress || 0"
              size="small"
              :show-info="true"
          />
          <span v-else>-</span>
        </template>

        <template slot="taskTimeSlot" slot-scope="text, record">
          <div>开始: {{ record.startTime }}</div>
          <div>结束: {{ record.finishTime }}</div>
        </template>

        <template slot="timeConsumingSlot" slot-scope="text, record">
          <span style="color: #1890ff; font-weight: bold;">{{ record.timeConsuming }}</span>
        </template>

        <template slot="errorMessageSlot" slot-scope="text, record">
          <a-tooltip v-if="record.status === 3 && record.errorMessage" :title="record.errorMessage" placement="topLeft">
            <span>
              {{ record.errorMessage.length > 160 ? record.errorMessage.substring(0, 160) + '...' : record.errorMessage }}
            </span>
          </a-tooltip>
          <span v-else>-</span>
        </template>

        <template slot="fileSizeSlot" slot-scope="text, record">
          {{ formatFileSize(record.fileSize) }}
        </template>

        <span slot="action" slot-scope="text, record">
          <a-button
              v-if="record.status === 2 && record.realPath"
              type="link"
              size="small"
              :loading="downloadingTasks.has(record.id)"
              @click="downloadFile(record)"
          >
            {{ downloadingTasks.has(record.id) ? '下载中...' : '下载' }}
          </a-button>
        </span>
      </a-table>

      <!-- table区域-end -->
    </div>
  </a-card>
</template>

<script>
import {TableListMixin} from '@/situation/mixins/tableListMixin'
import {postRequest} from '@/libs/axios'
import {filterObj} from "utils/util";

export default {
  name: "ExportTaskList",
  mixins: [TableListMixin],
  data() {
    return {
      description: '这是导出任务管理页面',
      // 下载状态管理
      downloadingTasks: new Set(), // 正在下载的任务ID集合

      // 查询参数
      queryParam: {},
      refreshTimer: null, // 定时刷新定时器
      columns: [
        {
          title: '任务名称',
          align: "center",
          dataIndex: 'taskName',
          width: 200
        },
        {
          title: '任务类型',
          align: "center",
          width: 120,
          dataIndex: 'exportType',
          scopedSlots: {customRender: 'exportTypeSlot'}
        },
        {
          title: '状态',
          align: "center",
          width: 100,
          dataIndex: 'status',
          scopedSlots: {customRender: 'statusSlot'}
        },
        {
          title: '进度',
          align: "center",
          width: 140,
          dataIndex: 'progress',
          scopedSlots: {customRender: 'progressSlot'}
        },
        {
          title: '文件大小',
          align: "center",
          width: 120,
          dataIndex: 'fileSize',
          scopedSlots: {customRender: 'fileSizeSlot'}
        },
        {
          title: '创建时间',
          align: "center",
          width: 150,
          dataIndex: 'createTime'
        },
        {
          title: '任务时间',
          align: "center",
          width: 220,
          dataIndex: 'taskTime',
          scopedSlots: {customRender: 'taskTimeSlot'}
        },
        {
          title: '耗时（秒）',
          align: "center",
          width: 100,
          dataIndex: 'timeConsuming',
          scopedSlots: {customRender: 'timeConsumingSlot'}
        },
        {
          title: '错误信息',
          align: "center",
          width: 420,
          dataIndex: 'errorMessage',
          scopedSlots: {customRender: 'errorMessageSlot'}
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'},
          align: "center",
          width: 100,
          fixed: 'right'
        }
      ],
      url: {
        selectData: "/ndt/export/task/page",
        deleteData: "/ndt/export/task/delete"
      },
    }
  },
  mounted() {
    this.startRefreshTimer()
  },
  beforeDestroy() {
    this.stopRefreshTimer()
    // 清理下载状态
    this.downloadingTasks.clear()
  },
  methods: {
    // 获取状态颜色
    getStatusColor(status) {
      const colorMap = {
        0: 'orange',    // 待处理
        1: 'blue',      // 处理中
        2: 'green',     // 已完成
        3: 'red'        // 失败
      }
      return colorMap[status] || 'default'
    },

    // 获取任务类型中文名称
    getExportTypeText(exportType) {
      const typeMap = {
        'finance_order': '财务订单',
        'order': '订单管理',
        'customer_order': '客户订单',
        'point_record': '积分记录'
      }
      return typeMap[exportType] || exportType
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '-'
      const mb = bytes / (1024 * 1024)
      if (mb < 0.1) {
        const kb = bytes / 1024
        return kb.toFixed(1) + ' KB'
      }
      return mb.toFixed(1) + ' MB'
    },

    // 获取状态文本
    getStatusText(status) {
      const textMap = {
        0: '待处理',
        1: '处理中',
        2: '已完成',
        3: '失败'
      }
      return textMap[status] || '未知'
    },

    // 下载文件
    async downloadFile(record) {
      if (!record.realPath) {
        this.$message.warning('文件路径不存在')
        return
      }

      // 添加到下载中状态
      this.downloadingTasks.add(record.id)

      try {
        // 显示下载提示
        this.$message.loading('正在准备下载...', 2)

        // 模拟下载准备时间（可选）
        await new Promise(resolve => setTimeout(resolve, 500))

        // 创建下载链接
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = record.realPath
        link.setAttribute('download', record.fileName || `export_${record.id}.xlsx`)
        document.body.appendChild(link)
        link.click()

        // 清理
        setTimeout(() => {
          document.body.removeChild(link)
        }, 100)

        this.$message.destroy()
        this.$message.success('文件下载已开始')

      } catch (error) {
        console.error('下载文件失败:', error)
        this.$message.destroy()
        this.$message.error('下载文件失败: ' + (error.message || '未知错误'))
      } finally {
        // 移除下载中状态
        setTimeout(() => {
          this.downloadingTasks.delete(record.id)
        }, 1000) // 延迟1秒移除状态，让用户看到完成效果
      }
    },

    // 清理已完成任务
    clearCompletedTasks() {
      this.$confirm({
        title: '确认清理',
        content: '确定要清理所有已完成的任务吗？此操作不可恢复。',
        onOk: () => {
          postRequest('/ndt/export/task/clearCompleted').then(res => {
            if (res.code === 200) {
              this.$message.success('清理完成')
              this.loadData()
            } else {
              this.$message.error(res.msg || '清理失败')
            }
          }).catch(err => {
            this.$message.error('清理失败：' + err.message)
          })
        }
      })
    },

    // 开始定时刷新
    startRefreshTimer() {
      this.refreshTimer = setInterval(() => {
        // 只有当前页面有待处理或处理中的任务时才刷新
        const hasProcessingTasks = this.dataSource.some(item => item.status === 0 || item.status === 1)
        if (hasProcessingTasks) {
          // 静默刷新，保存当前loading状态
          const currentLoading = this.loading
          this.loading = false
          this.loadData()
          this.loading = currentLoading
        }
      }, 5000) // 每5秒刷新一次
    },

    // 停止定时刷新
    stopRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    },

    // 刷新数据
    refreshData() {
      this.loadData()
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.current = this.ipagination.current;
      param.size = this.ipagination.pageSize;
      delete param.startTimeRange; // 时间参数不传递后台
      if (this.superQueryParams) {
        param['superQueryParams'] = encodeURI(this.superQueryParams)
        param['superQueryMatchType'] = this.superQueryMatchType
      }
      return filterObj(param);
    },
    onDateChange: function (value, dateString) {
      this.queryParam.startTimeStart = dateString[0];
      this.queryParam.startTimeEnd = dateString[1];
    },
    onDateOk(value) {
      console.log(value);
    },
  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operator {
  margin-bottom: 16px;
}

.ant-tag {
  margin: 0;
}
</style>
